import React from 'react';
import loginExampleImage from './login-example-image.png';

/** Illustration for the Login Page Image example modal. */
const LoginPageImageExampleIllustration = () => (
  <img
    src={loginExampleImage}
    alt="Login page image example"
    style={{ width: '100%', height: 'auto' }}
  />
);

export default LoginPageImageExampleIllustration;
